export default function registerAvailabilityPicker(Alpine) {
  Alpine.data("availabilityPicker", (availabilityUrl) => ({
    selectedDate: null,
    selectedSlot: null,
    slots: [],
    loading: false,

    async fetchSlots(date) {
      this.selectedDate = date;
      this.selectedSlot = null;
      this.loading = true;

      try {
        const response = await fetch(`${availabilityUrl}?date=${date}`);
        if (response.ok) {
          this.slots = await response.json();
        } else {
          this.slots = [];
        }
      } catch {
        this.slots = [];
      } finally {
        this.loading = false;
      }
    },

    selectSlot(slot) {
      if (!slot.available) return;
      this.selectedSlot = slot;
    },

    formatTime(isoString) {
      const date = new Date(isoString);
      return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    }
  }));
}
